import { render } from "./AccountDelete.vue?vue&type=template&id=a03020ea&ts=true"
import script from "./AccountDelete.vue?vue&type=script&lang=ts"
export * from "./AccountDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__